export const cartEnabledLocales = new Set([
    'en-us', 'en-gb', 'de-de', 'de-at', 'en-eu', 'es-es', 'fr-fr', 'it-it', 'pl-pl', 'nb-no', 'nl-nl', 'da-dk', 'sv-se', 'fi-fi'
]);

